var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0078D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 10C11.3333 10.7364 10.7364 11.3333 10 11.3333C9.26362 11.3333 8.66667 10.7364 8.66667 10C8.66667 9.26362 9.26362 8.66667 10 8.66667C10.7364 8.66667 11.3333 9.26362 11.3333 10ZM8.18426 6.55279C8.35365 6.214 8.69992 6 9.07869 6H10.9213C11.3001 6 11.6463 6.214 11.8157 6.55279L12.206 7.33333H12.6667C13.403 7.33333 14 7.93029 14 8.66667V12C14 12.7364 13.403 13.3333 12.6667 13.3333H7.33333C6.59695 13.3333 6 12.7364 6 12V8.66667C6 7.93029 6.59695 7.33333 7.33333 7.33333H7.79399L8.18426 6.55279ZM12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.604ae19273ab188d1bf53a3ba24c3c9d.svg";
export { ForwardRef as ReactComponent };